import { numberWithSpaces } from "./tracking-data"


const parseDiscount = (dis) => {

	const sign = dis < 0 ? '+' : '-'
	const value = Math.abs(dis) < 1 ? dis * 100 : dis
	const unit = Math.abs(dis) < 1 ? '%' : '€'

	return `${sign}${numberWithSpaces(Math.abs(value))}${unit}`
}

const columnsPriceRules = [

    {
		name: 'name',
		selector: (row) => row.id,
        cell: (row) => row.name || row.id,
		sortable: true,
	},

    {
		name: 'web',
		selector: (row) => row.web,
		cell: (row) => Boolean(Number(row.web)) ? 'SI' : 'NO',
		sortable: true,
        width: '100px'
	},
    {
		name: 'rumba',
		selector: (row) => row.rumba,
		cell: (row) => Boolean(Number(row.rumba)) ? 'SI' : 'NO',
		sortable: true,
        width: '100px'
	},
    {
		name: 'cumulative',
		selector: (row) => row.cumulative,
		cell: (row) => Boolean(Number(row.cumulative)) ? 'SI' : 'NO',
		sortable: true,
        width: '100px'
	},

    {
		name: 'discount',
		selector: (row) => row.discount,
		cell: (row) => `${parseDiscount(row.discount)}`,
		sortable: true,
        width: '100px'
	},
   
	{
		name: 'availableFrom',
		selector: (row) => row.availableFrom,
		cell: (row) => new Date(row.availableFrom).toLocaleString('es-ES', {day: '2-digit', month: 'short', year: 'numeric'}),
		sortable: true,
        width: '200px'
	},
	{
		name: 'availableTo',
		selector: (row) => row.availableTo,
		cell: (row) => new Date(row.availableTo).toLocaleString('es-ES', {day: '2-digit', month: 'short', year: 'numeric'}),
		sortable: true,
        width: '200px'
	},
]

export default columnsPriceRules